export default function getInitials(name: string | null | undefined, size: string): string {
  const initialsSizeMap = {
    '2xs': getFirstInitial,
    xs: getFirstInitial,
    sm: getFirstInitial,
    md: getFirstInitial,
    lg: getFullInitials,
    xl: getFullInitials,
    '2xl': getFullInitials,
    '3xl': getFullInitials,
    '4xl': getFullInitials
  };

  return initialsSizeMap[size](name);
}

export function getFirstInitial(name: string | null | undefined): string {
  return name?.[0]?.toUpperCase() || '';
}

const formatInitial = (str: string) => str[0]?.toUpperCase();

export function getFullInitials(name: string | null | undefined): string {
  if (!name) return '';

  const [firstName, lastName] = name.split(' ');

  const hasOnlyFirstName = firstName && !lastName;

  return hasOnlyFirstName ? formatInitial(firstName) : `${formatInitial(firstName)}${formatInitial(lastName)}`;
}
